import './swipeFunction.js';
function popupCard(el) {
    for(let i = 0; i < el.length; i++) {
        el[i].addEventListener("click", () => {
            
            let cloneSlide = el[i];            
            cloneSlide.querySelector("img").removeAttribute('width');
            cloneSlide.querySelector("img").removeAttribute('height');

            overlay.querySelector(".large-slide").innerHTML = null;
            overlay.querySelector('.large-slide').innerHTML = cloneSlide.innerHTML;
            overlay.querySelector("img").src = overlay.querySelector("img").dataset.popupUrl;
            overlay.querySelector("img").removeAttribute('width');
            overlay.querySelector("img").removeAttribute('height');
            currentNumber.innerHTML = i + 1;
            overlay.classList.remove("d-none")
        });
    }
    nextSlideBtn.addEventListener("click", () => {
        nextSlidePopup(el);
    });
    prevSlideBtn.addEventListener("click", () => {
        prevSlidePopup(el);
    });
    document.addEventListener("swiped-right", () => {
        nextSlidePopup(el);
    });
    document.addEventListener("swiped-left", () => {
        prevSlidePopup(el);
    })
}
function closeBtns(el) {
    for(let n = 0; n < el.length; n++) {
        el[n].addEventListener("click", () => {
            overlay.classList.add('d-none');
            overlay.querySelector(".large-slide").innerHTML = null;
        });
    }
}

function nextSlidePopup(el) {
    for(let n = 0; n < el.length; n++) {
        console.log(overlay.querySelector("img").dataset.popupUrl)
        if(el[n].querySelector("img").dataset.popupUrl === overlay.querySelector("img").dataset.popupUrl) {
            if(el[n + 1]) {
                currentNumber.innerHTML = n + 2;
                console.log("------------" + n);
                el[n + 1].querySelector("img").removeAttribute('class');
                overlay.querySelector("img").src = "";
                overlay.querySelector('.large-slide').innerHTML = null;
                overlay.querySelector('.large-slide').innerHTML = el[n + 1].innerHTML;
                overlay.querySelector("img").removeAttribute('width');
                overlay.querySelector("img").removeAttribute('height');
                overlay.querySelector("img").src = el[n + 1].querySelector("img").dataset.popupUrl;
                return;
            } else {
                currentNumber.innerHTML = 1;
                overlay.querySelector('.large-slide').innerHTML = null;
                overlay.querySelector('.large-slide').innerHTML = el[0].innerHTML;
                overlay.querySelector("img").removeAttribute('width');
                overlay.querySelector("img").removeAttribute('height');
                overlay.querySelector("img").src = el[0].querySelector("img").dataset.popupUrl;
                return;
            }
        }
        console.log(el[n].querySelector("img").dataset.popupUrl)
    }
}

function prevSlidePopup(el) {
    total.innerHTML = el.length;
    for(let n = 0; n < el.length; n++) {
        console.log(overlay.querySelector("img").dataset.popupUrl)
        if(el[n].querySelector("img").dataset.popupUrl === overlay.querySelector("img").dataset.popupUrl) {
            if(el[n - 1]) {
                currentNumber.innerHTML = n === 0 ? el.length : n;
                console.log("------------");
                el[n - 1].querySelector('img').removeAttribute('class');
                overlay.querySelector('.large-slide').innerHTML = null;
                overlay.querySelector('.large-slide').innerHTML = el[n - 1].innerHTML;
                overlay.querySelector("img").removeAttribute('width');
                overlay.querySelector("img").removeAttribute('height');
                overlay.querySelector("img").src = el[n - 1].querySelector("img").dataset.popupUrl;
                return;
            } else {
                currentNumber.innerHTML = el.length;
                el[el.length - 1].querySelector("img").removeAttribute('class')
                overlay.querySelector('.large-slide').innerHTML = null;
                overlay.querySelector('.large-slide').innerHTML = el[el.length - 1].innerHTML;
                overlay.querySelector("img").removeAttribute('width');
                overlay.querySelector("img").removeAttribute('height');
                overlay.querySelector("img").src = el[el.length - 1].querySelector("img").dataset.popupUrl;
                return;
            }
        }
        console.log(el[n].querySelector("img").dataset.popupUrl)
    }
}

const slides = document.querySelectorAll('.swiper-slide');
const nextSlideBtn = document.querySelector(".next-slide-btn");
const prevSlideBtn = document.querySelector(".prev-slide-btn");
const currentNumber = document.getElementById("current");
const total = document.getElementById("total");
let overlay = document.querySelector(".gallery__overlay");
const closeBtn = document.querySelectorAll('.btn-close');

if(slides && overlay && closeBtn) {
    popupCard(slides);
    closeBtns(closeBtn);
}